import React, { memo } from "react";

import { useFormContext } from "react-hook-form";

import { RadioGroupInput, RouterActions, StyledHeading } from "@/components";
import { StyledQuestion } from "@/components/StyledQuestion";
import { useFieldValidation } from "@/hooks";
import { PageBaseProps } from "@/types/SolarFormProps";

import { customerType } from "./content.json";

export const CustomerType = memo(({ backRoute, nextRoute }: PageBaseProps) => {
  const { getValues } = useFormContext();
  const { isValid } = useFieldValidation({ fields: ["customerType"] });

  const determineRedirect = async () => {
    if (await isValid()) {
      const type = getValues("customerType");

      if (type === customerType.oldOption.business.value) {
        window.location.href = customerType.oldOption.business.redirectLink;
        return false;
      }

      if (type === customerType.oldOption.commercial.value) {
        window.location.href = customerType.oldOption.commercial.redirectLink;
        return false;
      }

      return true;
    }

    return false;
  };

  return (
    <StyledQuestion>
      <div>
        <StyledHeading>{customerType.heading}</StyledHeading>
        <RadioGroupInput
          data-id={customerType.id}
          name="customerType"
          label=""
          options={customerType.oldOption}
        />
        <br />
        <br />
      </div>
      <RouterActions
        onBackRoute={backRoute}
        onNextRoute={nextRoute}
        onNext={determineRedirect}
      />
    </StyledQuestion>
  );
});
